import React, { useState } from 'react';
import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';

export default function FeedbackButton() {
  const [open, setOpen]       = useState(false);
  const [text, setText]       = useState('');
  const [sending, setSending] = useState(false);
  const [done, setDone]       = useState(false);
  const [err, setErr]         = useState('');

  const submit = async () => {
    if (!text.trim()) return;
    setSending(true); setErr('');
    try {
      const fn = httpsCallable(functions, 'submitFeedback');
      await fn({ text: text.trim() });
      setDone(true);
      setText('');
      setTimeout(() => { setDone(false); setOpen(false); }, 2500);
    } catch (e) {
      setErr('Något gick fel. Försök igen.');
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-noprint="1"
        style={{
          position: 'fixed', bottom: 24, right: 24, zIndex: 900,
          background: '#1B2A4A', color: '#fff',
          border: 'none', borderRadius: 28, padding: '11px 20px',
          fontSize: 14, fontFamily: 'system-ui,sans-serif', fontWeight: 600,
          cursor: 'pointer', boxShadow: '0 2px 14px rgba(0,0,0,0.24)',
          display: 'flex', alignItems: 'center', gap: 7,
          transition: 'background 0.15s',
        }}
        onMouseEnter={e => e.currentTarget.style.background = '#2A3F6A'}
        onMouseLeave={e => e.currentTarget.style.background = '#1B2A4A'}
      >
        💡 Feedback
      </button>

      {open && (
        <div
          style={{
            position: 'fixed', inset: 0, zIndex: 950,
            background: 'rgba(0,0,0,0.42)', display: 'flex',
            alignItems: 'center', justifyContent: 'center', padding: 20,
          }}
          onClick={e => { if (e.target === e.currentTarget) setOpen(false); }}
        >
          <div style={{
            background: '#fff', borderRadius: 14, padding: 28,
            width: '100%', maxWidth: 480,
            boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
            fontFamily: 'system-ui,sans-serif',
          }}>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#1B2A4A', marginBottom: 6 }}>
              💡 Feedback &amp; idéer
            </div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 4 }}>
              Ge förslag och idéer kring portalen
            </div>
            <div style={{ fontSize: 13, color: '#aaa', marginBottom: 18 }}>
              Saknar du någon funktion, ge oss din feedback
            </div>

            {done ? (
              <div style={{ textAlign: 'center', padding: '28px 0', fontSize: 16, color: '#1D9E75', fontWeight: 600 }}>
                Tack! Din feedback är registrerad.
              </div>
            ) : (
              <>
                <textarea
                  autoFocus
                  value={text}
                  onChange={e => setText(e.target.value)}
                  placeholder="Skriv ditt förslag eller din feedback här..."
                  style={{
                    width: '100%', minHeight: 130, padding: '10px 14px',
                    border: '1.5px solid #ddd', borderRadius: 8, resize: 'vertical',
                    fontSize: 14, fontFamily: 'system-ui,sans-serif',
                    boxSizing: 'border-box', outline: 'none', color: '#333',
                    lineHeight: 1.5,
                  }}
                  onFocus={e => e.target.style.borderColor = '#1B2A4A'}
                  onBlur={e => e.target.style.borderColor = '#ddd'}
                />
                {err && (
                  <div style={{ color: '#D85A30', fontSize: 13, marginTop: 8 }}>{err}</div>
                )}
                <div style={{ display: 'flex', gap: 10, marginTop: 14, justifyContent: 'flex-end' }}>
                  <button
                    onClick={() => { setOpen(false); setText(''); setErr(''); }}
                    style={{
                      padding: '9px 18px', fontSize: 14, fontFamily: 'system-ui,sans-serif',
                      background: 'none', border: '1.5px solid #ddd', borderRadius: 8,
                      cursor: 'pointer', color: '#666',
                    }}
                  >
                    Avbryt
                  </button>
                  <button
                    onClick={submit}
                    disabled={sending || !text.trim()}
                    style={{
                      padding: '9px 22px', fontSize: 14, fontFamily: 'system-ui,sans-serif',
                      fontWeight: 600, background: '#1B2A4A', color: '#fff',
                      border: 'none', borderRadius: 8,
                      cursor: (sending || !text.trim()) ? 'default' : 'pointer',
                      opacity: !text.trim() ? 0.5 : 1,
                    }}
                  >
                    {sending ? 'Skickar...' : 'Skicka'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
